
































































































































import { Component, Mixins } from 'vue-property-decorator'
import LoginComponent from '@/components/LoginComponent.vue'
import ProjectsDisplay from '@/components/ProjectsDisplay.vue'
import FeatureLimitsDisplay from '@/components/FeatureLimitsDisplay.vue'

import AuthMixin from '@/mixins/AuthMixin'
import ProjectLimitsMixin from '@/mixins/ProjectLimitsMixin'
import ShowInvitesMixin from '@/mixins/ShowInvitesMixin'

import { deleteProject } from '@/database/projects'

import { sharedInstance as loading } from '@/signals/LoadingSignal'

import { sharedInstance as analytics } from '@/services/AnalyticsService'

enum LoadingState
{
	/* eslint-disable */
	CHECKING_AUTH,
	DONE
	/* eslint-enable */
}

@Component({
	components: {
		LoginComponent,
		ProjectsDisplay,
		FeatureLimitsDisplay
	}
})
export default class Dashboard extends Mixins(AuthMixin, ProjectLimitsMixin, ShowInvitesMixin)
{
	private state: LoadingState = LoadingState.CHECKING_AUTH
	private showNewUser = false

	get isAdmin()
	{
		return this.$store.getters['auth/isAdmin']
	}

	get templates()
	{
		return this.$store.getters['projects/templates']
	}

	get packages()
	{
		return this.$store.getters['projects/packages']
	}

	get showLogin()
	{
		return this.state === LoadingState.DONE && !this.isSignedIn
	}

	get sessionToken()
	{
		const token: string = this.$store.getters['auth/sessionToken']
		return token
	}

	mounted()
	{
		if (this.isSignedIn)
		{
			this.state = LoadingState.DONE
			return
		}

		this.state = LoadingState.CHECKING_AUTH

		loading.fire({ active: !this.isSignedIn })
		// display loading when not signed in to give time
		// for auto login to happen
		setTimeout(() => {
			this.state = LoadingState.DONE
			loading.fire({ active: false })
		}, 1500)

		analytics.setCurrentScreen('dashboard')
	}

	onUserAuthed(user: firebase.User | UserData)
	{
		this.state = LoadingState.DONE
		loading.fire({ active: false })

		const route = this.$route
		if (route.query.pro)
		{
			delete route.query.pro
			const baseUrl = window.location.origin
			const path = route.path

			// @ts-ignore
			history.replaceState(null, null, `${baseUrl}${path}`)
		}

		setTimeout(() => {
			this.showNewUser = this.projects.length <= 0
		}, 1000)
	}

	private handleOpenProject(project: Project)
	{
		const baseUrl = process.env.VUE_APP_STUDIO_URL
		let url = `${baseUrl}/${project.uid}`
		if (this.sessionToken)
		{
			url += `?token=${this.sessionToken}`
		}
		window.location.href = url
	}

	private handleOpenTemplate(project: Project)
	{
		const baseUrl = process.env.VUE_APP_TEMPLATE_BUILDER_URL
		window.location.href = `${baseUrl}/${project.uid}`
	}

	private handleOpenPackage(project: Project)
	{
		const baseUrl = process.env.VUE_APP_TEMPLATE_BUILDER_URL
		window.location.href = `${baseUrl}/${project.uid}`
	}

	private handleDeleteProject(project: Project)
	{
		this.$buefy.dialog.confirm({
			title: `Delete ${project.name}?`,
			message: 'This action cannot be undone.',
			cancelText: 'Nevermind',
			confirmText: 'Delete',
			type: 'is-danger',
			onConfirm: () => this.deleteProject(project)
		})
	}

	private async deleteProject(project: Project)
	{
		loading.fire({
			active: true,
			message: 'Deleting...'
		})

		await deleteProject(project.uid)

		loading.fire({ active: false })
	}
}
